import React, { useState, useEffect } from "react";
import http from "../../CommonAxios";
import { checkData, checkUndeNullBlank } from "../../ObjectExist";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const Partner = () => {
  const [apiData, setApiData] = useState({});
  const [loader, setLoader] = useState(false);

  const onApiInteg = () => {
    let data = { admin_id: 1 };
    setLoader(true);
    http
      .post(`/partner/front/list`, data)
      .then((res) => {
        setLoader(false);
        if (res.data.s === 1) {
          setApiData(res.data);
        }
      })
      .catch(function (err) {
        setLoader(false);
      });
  };
  useEffect(() => {
    onApiInteg();
  }, []);
  const PreviousArrow = (props) => {
    const { classNameName, style, onClick } = props;
    return (
      // <div
      //   classNameName={classNameName}
      //   style={{
      //     ...style,
      //     display: "block",
      //     background: "black",
      //     borderRadius: "50%",
      //   }}
      //   onClick={onClick}
      // >
      //   <FontAwesomeIcon
      //     icon={faChevronLeft}
      //     style={{ color: "#f0411b", fontSize: "2rem", padding: "10px" }}
      //   />
      // </div>
      <></>
    );
  };

  const NextArrow = (props) => {
    const { classNameName, style, onClick } = props;
    return (
      // <div
      //   classNameName={classNameName}
      //   style={{
      //     ...style,
      //     display: "block",
      //     background: "black",
      //     borderRadius: "50%",
      //   }}
      //   onClick={onClick}
      // >
      //   <FontAwesomeIcon
      //     icon={faChevronRight}
      //     style={{ color: "#f0411b", fontSize: "2rem", padding: "10px" }}
      //   />
      // </div>
      <></>
    );
  };
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow:
      checkData(apiData) &&
      checkData(apiData.data) &&
      Object.keys(apiData.data).length > 3
        ? 4
        : checkData(apiData) && checkData(apiData.data)
        ? Object.keys(apiData.data).length
        : "",
    // slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    prevArrow: <PreviousArrow />,
    nextArrow: <NextArrow />,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow:
            checkData(apiData) &&
            checkData(apiData.data) &&
            Object.keys(apiData.data).length > 1
              ? 2
              : checkData(apiData) && checkData(apiData.data)
              ? Object.keys(apiData.data).length
              : "",
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <section className="space-shape mt-n75 arrow-wrap shape-mockup-wrap teamall">
      {/* <div
        className="shape-bg background-image"
        style={{ backgroundImage: "url(./img/team_bg_1.png)" }}
      ></div> */}
      <div className="container z-index-common">
        <div className="title-area text-center">
          <span className="sub-title2">
            <h4 className="sec-title-ndm" style={{ color: "#AB1300" }}>MEET OUR PARTNERS</h4>
            {/* <div className="line"></div>
            <img
              className="title-shape"
              src="./img/title_shape.png"
              alt="title shape"
            /> */}
          </span>
        </div>
        <Slider {...settings}>
          {checkData(apiData) && checkData(apiData.data)
            ? apiData.data.map((item, index) => (
                <div
                  // className={`team-grid ${index < 2 ? "ndn-border" : ""}`}
                  key={index}
                >
                  <a
                    href={item.website_link || "#"}
                    target="_blank"
                    rel="noopener noreferrer"
                    tabIndex={-1}
                    aria-label={item.title || "partner link"}
                    className="partner-link"
                  >
                    <div className="team-grid_img d-flex justify-content-center align-items-center">
                      {checkUndeNullBlank(item.image) ? (
                        <img src={`${apiData.path}/${item.image}`} alt={item.title || "partner logo"} />
                      ) : (
                        <img src="./img/team_1_1.jpg" alt="iovivc" />
                      )}
                      <div className="virticle_line" style={{ borderLeft: "3px solid #7e7d7dff", height: "120px", marginBottom: "80px" }} />
                    </div>
                  </a>
                    <div class="team-grid_info">
                    <h4 class="team-grid_title_ndm">
                      <a href={item.website_link} tabindex="-1" target="_blank">
                        {item.title}
                      </a>
                    </h4>
                    <span class="team-grid_desig">{item.designation}</span>
                  </div>
                </div>
              ))
            : ""}
        </Slider>

        <div
          className="row slider-shadow vs-carousel slick-initialized slick-slider"
          data-slide-show="4"
          data-lg-slide-show="3"
          data-sm-slide-show="2"
          data-arrows="true"
        >
          <div className="slick-list draggable">
            <div
              className="slick-track"
              style={{
                opacity: 1,
                width: "4382px",
                transform: "translate3d(-2191px, 0px, 0px)",
                transition: "transform 1000ms ease 0s",
              }}
            >
              <div
                className="col-lg-4 col-sm-6 slick-slide slick-cloned"
                style={{ width: "313px" }}
                tabindex="-1"
                data-slick-index="-4"
                id=""
                aria-hidden="true"
              ></div>
            </div>
          </div>
        </div>
      </div>
      {/* <div
        className="shape-mockup jump-reverse z-index-3 d-none d-xl-block"
        style={{ top: "14%", right: "0%" }}
      >
        <img src="./img/circle-4.png" alt="iovivc" />
      </div> */}
      {/* <div className="section-after">
        <img src="./img/curved-shape-bottom.png" alt="iovivc" />
      </div> */}
    </section>
    // <> </>
  );
};
export default Partner;
